import { PromotionType } from "@/states/promotion-state";
import { defineComponent, PropType } from "@vue/composition-api"

export default defineComponent({
    props: {
        status: {
            type: String as PropType<PromotionType>,
            default: 'none',
        },
        isSelected: {
            type: Boolean,
            default: true,
        },
        forPromotion: {
            type: String as PropType<PromotionType>,
            default: 'none',
        },
        description: {
            type: String as PropType<PromotionType>,
            default: null,
            required: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        }
    },
    emits: ['selected'],
    setup(_, context) {

        const emitSelected = () => {
            context.emit('selected');
        };

        return {
            emitSelected,
        };
    }
})